export class BoundingBox {
  protected bounded: boolean;
  protected maxLat: number;
  protected maxLon: number;
  protected minLat: number;
  protected minLon: number;

  public constructor(maxLat: null | number, maxLon: null | number, minLat: null | number, minLon: null | number) {
    this.bounded = null != maxLat && null != maxLon && null != minLat && null != minLon;

    if (this.bounded) {
       
      this.maxLat = maxLat!.valueOf();
       
      this.maxLon = maxLon!.valueOf();
       
      this.minLat = minLat!.valueOf();
       
      this.minLon = minLon!.valueOf();
    }
  }
  public static isDifferent(bbox1: BoundingBox, bbox2: BoundingBox): boolean {
    const bbox1Array = bbox1 == null ? [] : bbox1.asArray();
    const bbox2Array = bbox2 == null ? [] : bbox2.asArray();

    return JSON.stringify(bbox1Array) !== JSON.stringify(bbox2Array);
  }

  static makeFromArray(boundsArray: Array<unknown>): BoundingBox {
    return new BoundingBox(
      Number(boundsArray[0]).valueOf(),
      Number(boundsArray[1]).valueOf(),
      Number(boundsArray[2]).valueOf(),
      Number(boundsArray[3]).valueOf(),
    );
  }

  static makeUnbounded(): BoundingBox {
    return new BoundingBox(null, null, null, null);
  }

  // protected toPrecision(value: number): number {
  //   return Math.round(value * Math.pow(10, this.PRECISION_DP)) / Math.pow(10, this.PRECISION_DP);
  // }

  getMaxLat(): number {
    return this.maxLat;
  }
  getMaxLon(): number {
    return this.maxLon;
  }
  getMinLat(): number {
    return this.minLat;
  }
  getMinLon(): number {
    return this.minLon;
  }
  isBounded(): boolean {
    return this.bounded;
  }
  asArray(): [number, number, number, number] {
    return [this.getMaxLat(), this.getMaxLon(), this.getMinLat(), this.getMinLon()];
  }
}
